<template>
    <div class="tw:space-y-4">
        <div class="tw:mb-4 tw:px-6">
            <h2 class="tw:text-sm tw:font-semibold tw:text-gray-500 tw:uppercase tw:tracking-wide tw:my-1">
                Parcelas
            </h2>
            <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:my-1">
                Parcelas compradas por el usuario
            </p>
        </div>

        <SimpleTable
            :flat="true"
            :columns="columns"
            :data="items"
            :skeleton="loading"
            :skeleton-rows="5"
            empty-text="No tiene parcelas compradas"
            :default-col-width="defaultColWidth"
        >
            <template #skeleton-header-parcela_numero>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-20"></div>
            </template>
            <template #skeleton-header-zona_nombre>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-10"></div>
            </template>
            <template #skeleton-header-precio>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-12"></div>
            </template>
            <template #skeleton-header-user_name>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-14"></div>
            </template>
            <template #skeleton-header-pdf_url>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-12"></div>
            </template>

            <template #skeleton-parcela_numero>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-14"></div>
            </template>
            <template #skeleton-zona_nombre>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-20"></div>
            </template>
            <template #skeleton-precio>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-10"></div>
            </template>
            <template #skeleton-user_name>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-20"></div>
            </template>
            <template #skeleton-pdf_url>
                <div class="tw:h-8 tw:w-14 tw:bg-gray-200 tw:rounded"></div>
            </template>

            <template #cell-precio="{ row }">
                {{ row.parcela_ticket?.price }}€
            </template>

            <template #cell-user_name="{ row }">
                {{ row.user?.name }}
            </template>

            <template #cell-pdf_url="{ row }">
                <Button
                    v-if="row.pdf_url"
                    variant="primary"
                    :href="row.pdf_url"
                    target="_blank"
                >
                    PDF
                </Button>
                <span v-else class="tw:text-gray-400">-</span>
            </template>
        </SimpleTable>
    </div>
</template>

<script setup>
    import { ref, onMounted } from 'vue';
    import SimpleTable from '@/modules/admin/ui/table/SimpleTable.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import usuariosService from '@/services/admin/bases/usuariosService';

    const props = defineProps({
        listaId: { type: [String, Number], required: true },
        userId: { type: [String, Number], required: true },
        defaultColWidth: {
            type: String,
            default: '140px'
        }
    });

    const items = ref([]);
    const loading = ref(false);

    const columns = [
        { key: 'parcela_numero', label: 'Nº Parcela' },
        { key: 'zona_nombre', label: 'Zona' },
        { key: 'precio', label: 'Precio' },
        { key: 'user_name', label: 'Usuario' },
        { key: 'pdf_url', label: 'PDF' },
    ];

    async function fetchParcelas() {
        loading.value = true;

        try {
            const allParcelas = await usuariosService.getParcelas({
                lista_id: props.listaId,
            });

            // Filtro client-side por user_id (la API no filtra por usuario)
            items.value = [];
            allParcelas.forEach(pedido => {
                if (!pedido.parcelas || !Array.isArray(pedido.parcelas)) return;

                pedido.parcelas.forEach(parcela => {
                    if (parcela.user && parcela.user.id === Number(props.userId)) {
                        items.value.push({
                            parcela_numero: parcela.parcela_numero,
                            zona_nombre: parcela.zona?.nombre || '-',
                            parcela_ticket: parcela.parcela_ticket,
                            user: parcela.user,
                            pdf_url: parcela.pdf_url,
                        });
                    }
                });
            });
        } catch (err) {
            console.error('Error al cargar parcelas:', err);
            items.value = [];
        } finally {
            loading.value = false;
        }
    }

    onMounted(() => {
        fetchParcelas();
    });
</script>
